import { translate } from '@/ui/i18n';

export class FormatColumnHeader {
  static translate(category: string, propName: string): string {
    const defaultValue = propName;
    const translateKey = `ImpactQuestion.${category}.${propName}Title`;
    const out = translate(translateKey, defaultValue);
    return out;
  }
}
